<template>
  <div class="index">
    <div class="banner">
      <SwiperBanner />
      <UserBox />
    </div>
    <div class="layout-main">
      <div class="wp-con">
        <FirstBlock />
        <SecondBlock />
        <ActRec />
        <GameBrand />
        <ActBanner />
      </div>
      <FloatingAd />
    </div>
    <MsgPop />
  </div>
</template>

<script>
import FirstBlock from '~/components/home/FirstBlock'
import SecondBlock from '~/components/home/SecondBlock'
import ActRec from '~/components/home/ActRec'
import ActBanner from '~/components/home/ActBanner'
import GameBrand from '~/components/home/GameBrand'
import FloatingAd from '~/components/home/FloatingAd'

import UserBox from '~/components/home/UserBox'
import SwiperBanner from '~/components/home/SwiperBanner'
import MsgPop from '~/components/home/MsgPop'
export default {
  components: {
    SecondBlock,
    FirstBlock,
    ActRec,
    ActBanner,
    GameBrand,
    FloatingAd,
    UserBox,
    SwiperBanner,
    MsgPop
  },
  data() {
    return {}
  },
  mounted() {
    this.$xlaPush('home_page_show')
  }
}
</script>

<style lang="scss" src="~/assets/scss/index.scss"></style>
